

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import type { Comanda, ComandaForm, FormLoja } from '@/models'
import { ComandaUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import CardDeAcoesDaComanda from '@/components/loja/CardDeAcoesDaComanda.vue'
import DialogoDeCadastroDeComandas from '../DialogoDeCadastroDeComandas.vue'

@Component({
	components: { CardDeAcoesDaComanda, DialogoDeCadastroDeComandas },
})
export default class SecaoComandas extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja
	@Prop({ type: Boolean, default: true }) podeEditar!: boolean

	busca = ''
	comandasEncontradas: ComandaForm[] | null = null
	comandaUseCase = new ComandaUseCase()

	get lojaSincronizada() {
		return this.loja
	}

	set lojaSincronizada(loja: FormLoja) {
		this.$emit('update:loja', loja)
	}

	get comandasOrdenadas() {
		const comandas = this.comandasEncontradas !== null ? this.comandasEncontradas : this.loja.comandas || []
		return [...comandas].sort((comandaA, comandaB) => comandaA.nome.localeCompare(comandaB.nome))
	}

	@Watch('busca')
	async buscarComandas() {
		if (!this.busca) {
			this.comandasEncontradas = null
			return
		}
		try {
			const pagina = await this.comandaUseCase.getComandas(this.busca, this.loja.id)
			this.comandasEncontradas = pagina.content
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	inserirComanda(comanda: Comanda) {
		if (this.loja.comandas === null) this.loja.comandas = []
		this.loja.comandas.push(comanda)
	}
}
